import { render, staticRenderFns } from "./MainBtn.vue?vue&type=template&id=3a70083e&scoped=true"
import script from "./MainBtn.vue?vue&type=script&lang=js"
export * from "./MainBtn.vue?vue&type=script&lang=js"
import style0 from "./MainBtn.vue?vue&type=style&index=0&id=3a70083e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70083e",
  null
  
)

export default component.exports